import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import last from 'lodash/last';
import isUndefined from 'lodash/isUndefined';
import uniqueId from 'lodash/uniqueId';
import takeRight from 'lodash/takeRight';
import { getAutoLoginUrl } from '@kso/ui/lib/request';
import { openFunctionPage } from '@kso/sdk-super/lib/mdocs';
import UA from '@kso/ui/lib/utils/ua';
import get from 'lodash/get';

var mergeUrlQuery = function mergeUrlQuery(qs) {
  return Object.keys(qs).reduce(function (pre, cur) {
    return !pre ? "?".concat(cur, "=").concat(qs[cur]) : "".concat(pre, "&").concat(cur, "=").concat(qs[cur]);
  }, '');
};
function getExtName(filename) {
  var ftype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var ignoreImg = arguments.length > 2 ? arguments[2] : undefined;
  if (~['folder', 'delfolder'].indexOf(ftype)) {
    return 'folder';
  }
  var fileSplit = filename ? filename.split('.') : 'unknown';
  var imgList = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'webp'];
  var ext;
  if (fileSplit.length === 1 && ftype !== 'file' && ftype !== 'delfile' && ftype !== 'sharefile') {
    return 'folder';
  }
  ext = fileSplit.length === 1 ? 'unknown' : last(fileSplit).toLowerCase();
  if (!ignoreImg && imgList.indexOf(ext) !== -1) {
    ext = 'img';
  }
  return ext;
}

// 手机号脱敏掩码处理
var phoneMask = function phoneMask() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return phone.indexOf('*') === -1 ? phone.replace(/(\d{3})\d*(\d{3})/, '$1***$2') : phone;
};
var getHost = function getHost(link) {
  return link.match(/^https?:\/\/(.+\.\w+)/)[0];
};
var openLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(link) {
    var isWps,
      params,
      isOpened,
      _yield$getAutoLoginUr,
      data,
      JSONStr,
      ext,
      thumbnail,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isWps = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          params = _args.length > 2 ? _args[2] : undefined;
          _context.prev = 2;
          isOpened = false;
          if (!(isWps || UA.WPS)) {
            _context.next = 17;
            break;
          }
          _context.prev = 5;
          _context.next = 8;
          return getAutoLoginUrl({
            cb: link,
            sync_status: true
          });
        case 8:
          _yield$getAutoLoginUr = _context.sent;
          data = _yield$getAutoLoginUr.data;
          JSONStr = JSON.stringify({
            method: 'common.util.openUrl',
            params: {
              url: data.url
            }
          });
          window.cefQuery({
            request: 'fromJSAsynCall("' + JSONStr + '")',
            persistent: false
          });
          isOpened = true;
          // eslint-disable-next-line
          _context.next = 17;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](5);
        case 17:
          if (!isOpened) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return");
        case 19:
          if ((UA.wxpcmini || UA.qqpcmini) && get(window, 'wx.miniProgram.navigateTo')) {
            window.wx.miniProgram.navigateTo({
              url: '/pages/pcweb/pcweb?url=' + encodeURIComponent(link)
            });
          } else if (UA.isTabletClient) {
            ext = params && params.type === 'calendar' ? 'rili' : params.type;
            thumbnail = params.thumbnail;
            window.open(link, {
              ext: ext,
              thumbnail: thumbnail
            });
          } else {
            window.open(link);
          }
          // eslint-disable-next-line
          _context.next = 24;
          break;
        case 22:
          _context.prev = 22;
          _context.t1 = _context["catch"](2);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 22], [5, 15]]);
  }));
  return function openLink(_x) {
    return _ref.apply(this, arguments);
  };
}();
var openPage = function openPage(link) {
  var isWebsite = link.indexOf('http') === 0;
  if (UA.isTabletClient && isWebsite) {
    openFunctionPage({
      url: link
    });
  }
  openLink(link);
};

/**
 * 创建能够缓存函数计算结果的工厂函数
 * @param {function} fn 需要缓存计算结果的函数
 * @param {number} [expire = 60 * 60 * 24] 缓存多长时间后失效，单位秒，默认一天
 */
var createFnWithCache = function createFnWithCache(fn) {
  var expire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60 * 60 * 24;
  if (typeof window === 'undefined') {
    return;
  }
  var cache = {};
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var key,
      now,
      result,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          key = JSON.stringify(_args2);
          now = new Date().getTime();
          if (!(cache[key] && cache[key].expiredAt > now)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", cache[key].data);
        case 4:
          _context2.next = 6;
          return fn.apply(this, _args2);
        case 6:
          result = _context2.sent;
          cache[key] = {
            data: result,
            expiredAt: now + expire * 1000
          };
          return _context2.abrupt("return", result);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this);
  }));
};

// 统一格式化接口返回成员属性
var formatMember = function formatMember(info) {
  var keysMap = {
    recent_id: 'userid',
    contact_id: 'userid',
    mark_name: 'markname',
    nick_name: 'name',
    nickname: 'name',
    user_name: 'name',
    id: 'userid',
    user_id: 'userid'
  };
  Object.keys(keysMap).forEach(function (key) {
    if (isUndefined(info[keysMap[key]]) && !isUndefined(info[key])) {
      info[keysMap[key]] = info[key];
    }
  });
  info.id = uniqueId();
  info.leaf = true;
};

/**
 * 获取公司组织结构的名字
 * @param {string} path 接口返回的组织结构路径参数
 * @returns {Array} 名称数组，第一个为公司名称，第二个为所在部门的路径，取最后两个
 */
var getOrgNames = function getOrgNames(path) {
  if (!path) {
    return [];
  }
  var deptPaths = path.split('/');
  var companyName = deptPaths.shift();
  var deptName = takeRight(deptPaths, 2).join('/');
  return [companyName, deptName];
};

export { createFnWithCache, formatMember, getExtName, getHost, getOrgNames, mergeUrlQuery, openLink, openPage, phoneMask };
